class Transactions {

  constructor(client) {
    this.client = client;
  }

  async getTransactions() {
    return this.client.request("transactions", "GET");
  }
}

module.exports = Transactions;
